import {Items} from '../../../../api/user'

export const getUserById = (commit, id) => {
      commit('updateOneToList', Items.find(element => element.uuid === id))
}

export const getList = (commit) => {
  commit('updateLoading', true)
  commit('updateList', Items)
  commit('updateLoading', false)
}

export const getOne = (commit, id) => {
  commit('updateOne', Items.find(element => element._id === id))
}